import { gqlClient as apolloClient } from "@root/apollo/apollo-options";
import { registerMicroApps as register } from "qiankun";
import { chain, includes, merge } from "lodash";
import router from "@root/router";

export const config = [
  {
    name: "staff-app-k-one-frontend",
    entry: window.__GTECH_VARIABLES_KONE_PRO_HOST__,
    activeRule: "/app/k-one-frontend",
    appCode: "K-ONE"
  },
  {
    name: "staff-app-k-one-tbr",
    entry: (window as any).__GTECH_VARIABLES_KONE_TBR_PRO_HOST__,
    activeRule: "/app/k-one-tbr",
    appCode: "WIN-TOGETHER-TBR"
  }
];

/**
 * 基于应用元信息生成应用的配置
 */
export function microAppsOptionsGen(apps) {
  return chain(config)
    .filter(({ name }) => includes(apps, name))
    .map(item =>
      merge(item, {
        container: ".gt-layout__qiankun-app-container",
        props: {
          loginOptions() {
            return {
              apolloClient,
              appCode: item.appCode
            };
          },
          mainRouter: router
        }
      })
    )
    .value();
}

export function registerMicroApps(apps) {
  const options = microAppsOptionsGen(apps);

  if (options.length) {
    register(options);
  }
}
